module.exports = {
  title: 'Loading Button Animation with Reanimated, RN Skia and Moti 🫣',
  author: 'Enzo Manuel Mangano',
  date: '2023-10-04',
  slug: 'loading-button',
  tags: ['reanimated', 'skia', 'moti'],
};
